import createAssigner from './_createAssigner.js';
import allKeys from './allKeys.js';

// Fill in a given object with default properties.
export default createAssigner(allKeys, true);



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/defaults.js
// module id = 517
// module chunks = 106